module.exports = __webpack_public_path__ + "static/media/car.634ad0f9.jpg";